import { APP_PLATFORM, PRODUCT } from '@/utils/constants';
import { getCookieValue } from '@/utils/cookies/client';
import { COOKIES } from '@/utils/cookies';
import type { AppPlatform } from '@/types/constants';

const ANDROID_AGENT = 'Android';

export const isXsell = () => process.env.PRODUCT === PRODUCT.XSELL;

/**
 * @deprecated
 */
export const isAndroid = (userAgent: string) => {
    if (userAgent) {
        return userAgent.includes(ANDROID_AGENT);
    }

    if (typeof navigator !== 'undefined' && navigator && navigator.userAgent) {
        return navigator.userAgent.includes(ANDROID_AGENT);
    }
};

/**
 * @deprecated
 */
export const isAndroidWrapper = () => {
    try {
        const isWrapper = window?.AndroidWrapper?.isWrapper() ?? window?.AndroidSportsbook?.isSportsbook();
        return !!isWrapper;
    } catch {
        return false;
    }
};

/**
 * @deprecated
 */
export const isIosWrapper = () => {
    try {
        const platformWrapper = getCookieValue(COOKIES.WRAPPER) as string;
        return platformWrapper.toLowerCase() === APP_PLATFORM.Ios.toLowerCase();
    } catch {
        return false;
    }
};

/**
 *
 * @deprecated
 */
export const getAppPlatform = (): AppPlatform => {
    if (isXsell()) {
        return APP_PLATFORM.Xsell;
    }

    if (isAndroidWrapper()) {
        return APP_PLATFORM.Android;
    }

    if (isIosWrapper()) {
        return APP_PLATFORM.Ios;
    }

    return APP_PLATFORM.Web;
};

const DLC_USER_AGENT = 'FDPoker';

/**
 * Returns true when the lobby is being rendered for the poker desktop client wrapper.
 * The desktop client identifies itself via the `FDPoker` user-agent token and is never
 * running inside the iOS or Android wrapper.
 *
 * Mirrors casino-web's `isPokerDesktopClient` and is used to suppress chrome (header,
 * footer, breadcrumbs, etc.) when the lobby is hosted by the desktop client.
 *
 * Prefer `useGlobalContext().isPokerDesktopClient` in components and
 * `getServerContext().isPokerDesktopClient` in server components — both are populated
 * from the request User-Agent during SSR. This client-only helper is a fallback for
 * utility code that runs outside of the React tree.
 */
export const isPokerDesktopClient = (): boolean => {
    if (process.env.PRODUCT !== PRODUCT.POKER) {
        return false;
    }

    if (typeof window === 'undefined') {
        return false;
    }

    if (getAppPlatform() !== APP_PLATFORM.Web) {
        return false;
    }

    return navigator.userAgent.includes(DLC_USER_AGENT);
};
